import {
  IMarkStepCompletedRequest,
  IMarkSubstepCompletedRequest,
  IOnboardHierarchyResponse,
  IOnboardStaticHierarchyResponse,
  IUpdateStepRequest,
} from "../contracts/Onboarding";
import { IZeosApiResponse } from "../contracts/ZeosApi";
import { OnboardStepEnum } from "../enums/Onboarding";
import {
  deleteDataAsync,
  getDataAsync,
  postDataAsync,
} from "../ZeosApiExecutor";
import { IOnboarding } from "./interfaces/IOnboarding";

const API_BASE_URL = `/Onboard`;

export const Onboarding: IOnboarding = {
  getStaticHierarchy: async (): Promise<
    IZeosApiResponse<IOnboardStaticHierarchyResponse>
  > => {
    const response = await getDataAsync<IOnboardStaticHierarchyResponse>(
      `${API_BASE_URL}/GetStaticHierarchy`,
      ""
    );
    return response;
  },

  getHierarchy: async (
    zeosUserId: number
  ): Promise<IZeosApiResponse<IOnboardHierarchyResponse>> => {
    const response = await getDataAsync<IOnboardHierarchyResponse>(
      `${API_BASE_URL}/GetHierarchy/${zeosUserId}`,
      ""
    );
    return response;
  },

  // Utility methods
  resetOnboarding: async (
    zeosUserId: number
  ): Promise<IZeosApiResponse<boolean>> => {
    const response = await postDataAsync<boolean>(
      `${API_BASE_URL}/ResetOnboarding/${zeosUserId}`,
      {}
    );
    return response;
  },

  getOnboardStep: async (
    zeosUserId: number
  ): Promise<IZeosApiResponse<OnboardStepEnum>> => {
    const response = await getDataAsync<OnboardStepEnum>(
      `${API_BASE_URL}/GetStep/${zeosUserId}`,
      ""
    );
    return response;
  },

  getSendSummaryEmail: async (zeosUserId: number) => {
    const response = await getDataAsync<any>(
      `${API_BASE_URL}/SendSummaryEmail/${zeosUserId}`,
      ""
    );
    return response;
  },

  // Demo user management
  demoUserDelete: async (): Promise<IZeosApiResponse<boolean>> => {
    const response = await deleteDataAsync<boolean>(
      `${API_BASE_URL}/DemoUserDelete`,
      {}
    );
    return response;
  },

  demoUserCreate: async (): Promise<IZeosApiResponse<boolean>> => {
    const response = await getDataAsync<boolean>(
      `${API_BASE_URL}/DemoUserCreate`,
      ""
    );
    return response;
  },

  // Add missing methods
  updateStep: async (
    request: IUpdateStepRequest
  ): Promise<IZeosApiResponse<boolean>> => {
    const response = await postDataAsync<boolean>(
      `${API_BASE_URL}/UpdateStep`,
      request
    );
    return response;
  },

  markStepCompleted: async (
    request: IMarkStepCompletedRequest
  ): Promise<IZeosApiResponse<boolean>> => {
    const response = await postDataAsync<boolean>(
      `${API_BASE_URL}/MarkStepCompleted`,
      request
    );
    return response;
  },

  markSubstepCompleted: async (
    request: IMarkSubstepCompletedRequest
  ): Promise<IZeosApiResponse<boolean>> => {
    const response = await postDataAsync<boolean>(
      `${API_BASE_URL}/MarkSubstepCompleted`,
      request
    );
    return response;
  },

  isStepCompleted: async (
    zeosUserId: number,
    stepId: number
  ): Promise<IZeosApiResponse<boolean>> => {
    const response = await getDataAsync<boolean>(
      `${API_BASE_URL}/IsStepCompleted/${zeosUserId}/${stepId}`,
      ""
    );
    return response;
  },

  isSubstepCompleted: async (
    zeosUserId: number,
    substepId: number
  ): Promise<IZeosApiResponse<boolean>> => {
    const response = await getDataAsync<boolean>(
      `${API_BASE_URL}/IsSubstepCompleted/${zeosUserId}/${substepId}`,
      ""
    );
    return response;
  },
};
